import clsx from 'clsx'
import { useAtomValue } from 'jotai'
import { SlidersHorizontal } from 'lucide-react'
import React, { useMemo } from 'react'
import { aFiltersFind, aUser } from '~/atoms'
import { Listing, getLeaseMetaValues, getMetaLabelValues } from '~/models'
import { cn } from '~/utils'

ListingMeta.defaultProps = {
  isOffMarket: false,
}
export default function ListingMeta({
  className,
  listing,
  isOffMarket,
}: {
  className?: string
  listing: Listing
  isOffMarket?: boolean
}) {
  const user = useAtomValue(aUser)
  const meta = listing.meta as { [key: string]: any }
  const filters = useAtomValue(aFiltersFind)

  const filtersString = useMemo(() => {
    return JSON.stringify(filters).toLowerCase()
  }, [filters])

  const renderLeaseMeta = () => {
    const values = getLeaseMetaValues(listing)
    if (values.length === 0) {
      return null
    }
    return (
      <>
        {values.map(({ label, value }, index) => {
          return (
            <React.Fragment key={index}>
              <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
                {label}
              </dt>
              <dd className="col-span-7 py-0.5 text-right font-semibold">
                {value}
              </dd>
            </React.Fragment>
          )
        })}
      </>
    )
  }

  // const renderCommission = () => {
  //   if (!user || !meta.commission) {
  //     return null
  //   }
  //   let text = `${meta.commission}%`
  //   if (meta.commissionSplit) {
  //     if (meta.listingCommission && meta.outsideCommission) {
  //       text = `${meta.commission}% split ${meta.listingCommission}% - ${meta.outsideCommission}%`
  //     } else {
  //       text = `${meta.commission}% split`
  //     }
  //   }
  //   return (
  //     <>
  //       <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
  //         Commission
  //       </dt>
  //       <dd className="col-span-7 py-0.5 text-right font-semibold">{text}</dd>
  //     </>
  //   )
  // }

  return (
    <dl className={clsx(className, 'grid grid-cols-12 text-base')}>
      {listing.offMarketDate && (
        <>
          <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
            Transacted
          </dt>
          <dd className="col-span-7 py-0.5 text-right font-semibold">
            {listing.offMarketDate.split('T')[0]}
          </dd>
        </>
      )}
      {!isOffMarket && (
        <>
          {renderLeaseMeta()}
          {getMetaLabelValues(meta).map(({ key, label, value }, index) => {
            return (
              <React.Fragment key={index}>
                <dt
                  className={cn(
                    'col-span-5 inline-flex items-center py-0.5 font-medium text-muted-foreground',
                    filtersString.includes(
                      key
                        .replace('filters', 'meta')
                        .replace('min', '')
                        .replace('max', '')
                        .toLowerCase()
                    ) && 'font-semibold text-foreground'
                  )}>
                  {filtersString.includes(
                    key
                      .replace('filters', 'meta')
                      .replace('min', '')
                      .replace('max', '')
                      .toLowerCase()
                  ) && <SlidersHorizontal className="mr-1 h-4 w-4" />}
                  {label}
                </dt>
                <dd className="col-span-7 py-0.5 text-right font-semibold">
                  {value}
                </dd>
              </React.Fragment>
            )
          })}
          {/* {renderCommission()} */}
          <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
            County
          </dt>
          <dd className="col-span-7 py-0.5 text-right font-semibold">
            {listing.property.county}
          </dd>
        </>
      )}
      {listing.availableDate && (
        <>
          <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
            Available
          </dt>
          <dd className="col-span-7 py-0.5 text-right font-semibold">
            {listing.availableDate?.split('T')[0] ?? ''}
          </dd>
        </>
      )}
      <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
        Created
      </dt>
      <dd className="col-span-7 py-0.5 text-right font-semibold">
        {listing.created.split('T')[0]}
      </dd>
      <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
        Updated
      </dt>
      <dd className="col-span-7 py-0.5 text-right font-semibold">
        {listing.modified.split('T')[0]}
      </dd>

      <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
        Listing ID
      </dt>
      <dd className="col-span-7 py-0.5 text-right font-semibold">
        {listing.tid}
      </dd>
      {listing.property.parcelApn && (
        <>
          <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
            Parcel APN
          </dt>
          <dd className="col-span-7 py-0.5 text-right font-semibold">
            {listing.property.parcelApn}
          </dd>
        </>
      )}
      {listing.property.additionalParcelApns &&
        listing.property.additionalParcelApns.length > 0 && (
          <>
            <dt className="col-span-5 py-0.5 font-medium text-muted-foreground">
              Additional Parcel APNs
            </dt>
            <dd className="col-span-7 py-0.5 text-right font-semibold">
              {listing.property.additionalParcelApns.map((parcel) => (
                <p key={parcel}>{parcel}</p>
              ))}
            </dd>
          </>
        )}
    </dl>
  )
}
